import { useMutation } from 'react-query'

import { APIError } from '../../../utils'
import { deleteContact as deleteContactQuery } from '../query-api'

export interface UseDeleteContactProps {
  onSuccess?: (contactId: string) => void
  onError?: (error: APIError) => void
}

export const useDeleteContact = ({ onSuccess, onError }: UseDeleteContactProps) => {
  const {
    mutate,
    isLoading: isProcessing,
    ...rest
  } = useMutation(deleteContactQuery, {
    onSuccess: (_, contactId) => onSuccess?.(contactId),
    onError,
  })

  return { delete: mutate, isProcessing, ...rest }
}
